import React from 'react';
import PropTypes from 'prop-types';
import items from './items';
import IntroSectionMobile from './IntroSectionMobile/IntroSectionMobile';
import IntroSectionDesktop from './IntroSectionDesktop/IntroSectionDesktop';

export default function IntroSection({ isMobile }) {
  return isMobile ? <IntroSectionMobile items={items} /> : <IntroSectionDesktop items={items} />;
}

IntroSection.propTypes = {
  isMobile: PropTypes.bool.isRequired,
};
